module.exports = __webpack_public_path__ + "static/media/Leccion-10-01-GDV-La-Presencia-de-Dios.356fbddf.pdf";